module.exports = __webpack_public_path__ + "img/z_06_bastien-nvs.2fdf91e2.jpg";